import { nettoyerSpans, normaliserSpans } from "./helpers.mjs";

// ========================================
// COULEUR DE TEXTE (lettre par lettre)
// ===================================

// =====
export function couleurTexte(couleur) {
	const sel = window.getSelection();
	if (!sel.rangeCount) return;

	const range = sel.getRangeAt(0);
	if (range.collapsed) return;

	let editableParent = range.commonAncestorContainer;
	if (editableParent.nodeType === Node.TEXT_NODE) {
		editableParent = editableParent.parentElement;
	}
	while (
		editableParent &&
		editableParent.nodeType === Node.ELEMENT_NODE &&
		!editableParent.hasAttribute("contenteditable")
	) {
		editableParent = editableParent.parentElement;
	}

	// Sauvegarder la position
	const texteAvantSelection = range.cloneRange();
	texteAvantSelection.selectNodeContents(editableParent);
	texteAvantSelection.setEnd(range.startContainer, range.startOffset);
	const startOffset = texteAvantSelection.toString().length;
	const endOffset = startOffset + range.toString().length;

	// Normaliser les spans
	normaliserSpans(editableParent);

	// Recréer la sélection
	let currentOffset = 0;
	let startNode = null;
	let startPos = 0;
	let endNode = null;
	let endPos = 0;

	const walker = document.createTreeWalker(
		editableParent,
		NodeFilter.SHOW_TEXT,
		null,
		false
	);

	let node;
	while ((node = walker.nextNode())) {
		const nodeLength = node.textContent.length;

		if (!startNode && currentOffset + nodeLength > startOffset) {
			startNode = node;
			startPos = startOffset - currentOffset;
		}

		if (!endNode && currentOffset + nodeLength >= endOffset) {
			endNode = node;
			endPos = endOffset - currentOffset;
			break;
		}

		currentOffset += nodeLength;
	}

	if (startNode && endNode) {
		try {
			const newRange = document.createRange();
			newRange.setStart(startNode, startPos);
			newRange.setEnd(endNode, endPos);
			sel.removeAllRanges();
			sel.addRange(newRange);
		} catch (e) {
			console.warn("Impossible de restaurer la sélection", e);
			return;
		}
	} else {
		return;
	}

	// Appliquer la couleur en place (sans toucher à la structure DOM)
	const finalRange = sel.getRangeAt(0);
	const fnStart = finalRange.startContainer;
	const fnEnd = finalRange.endContainer;
	const fnStartOff = finalRange.startOffset;
	const fnEndOff = finalRange.endOffset;

	const couleurClasses = [
		"couleur-red",
		"couleur-coral",
		"couleur-salmon",
		"couleur-orange",
		"couleur-gold",
		"couleur-yellow",
		"couleur-lime",
		"couleur-green",
		"couleur-olive",
		"couleur-teal",
		"couleur-cyan",
		"couleur-blue",
		"couleur-navy",
		"couleur-indigo",
		"couleur-purple",
		"couleur-magenta",
		"couleur-pink",
		"couleur-beige",
		"couleur-brown",
		"couleur-gray",
		"couleur-silver",
		"couleur-black",
		"couleur-white",
		"couleur-transparent",
	];

	function stylerSpan(span) {
		couleurClasses.forEach((cls) => span.classList.remove(cls));
		span.classList.add(`couleur-${couleur}`);
	}

	// Collecter les nœuds texte dans la sélection avec leurs offsets
	const walkerFinal = document.createTreeWalker(
		editableParent,
		NodeFilter.SHOW_TEXT,
		null,
		false
	);
	const toProcess = [];
	let inRange = false;
	let n;

	while ((n = walkerFinal.nextNode())) {
		if (n === fnStart) inRange = true;
		if (inRange) {
			toProcess.push({
				node: n,
				from: n === fnStart ? fnStartOff : 0,
				to: n === fnEnd ? fnEndOff : n.textContent.length,
			});
		}
		if (n === fnEnd) break;
	}

	// Traitement en ordre inverse pour préserver les positions DOM
	[...toProcess].reverse().forEach(({ node, from, to }) => {
		const parent = node.parentElement;
		if (parent.tagName === "SPAN" && !parent.classList.contains("entoure")) {
			stylerSpan(parent);
		} else {
			const text = node.textContent;
			const frag = document.createDocumentFragment();
			if (from > 0) frag.appendChild(document.createTextNode(text.slice(0, from)));
			for (let i = from; i < to; i++) {
				const s = document.createElement("span");
				s.textContent = text[i];
				stylerSpan(s);
				frag.appendChild(s);
			}
			if (to < text.length)
				frag.appendChild(document.createTextNode(text.slice(to)));
			parent.insertBefore(frag, node);
			node.remove();
		}
	});

	document.getElementById("couleur-texte").style.color = couleur;
	document.getElementById("couleur-texte").value = couleur;

	if (couleur === "white" || couleur === "transparent") {
		document.getElementById("couleur-texte").style.webkitTextStroke =
			"1px #000000";
	} else {
		document.getElementById("couleur-texte").style.webkitTextStroke = "0px";
	}

	// Optimiser les spans après l'opération
	nettoyerSpans(editableParent);
}
